import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";
export const TestimonialSlice = createSlice({
 name: "testimonial",
 initialState: {
  error: false,

  mailData: "",
  isMailLoaded: false,
 },
 reducers: {
  setMail: (state, { payload }) => {
   state.mailData = payload;
   state.isMailLoaded = true;
  },

  setError: (state) => {
   state.error = true;
  },

  setMailLoad: (state) => {
   state.isMailLoaded = false;
  },
 },
});

// Action creators are generated for each case reducer function
export const { setError, setMail, setMailLoad } = TestimonialSlice.actions;

export default TestimonialSlice.reducer;

export function handleGenerateTestimonial(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/testimonial/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleTestimonialLoading() {
 return (dispatch) => {
  dispatch(setMailLoad());
 };
}
